import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RfTransactionListPageUI from './RfTransactionListPageUI.js'

class RfTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      customerInvoiceList: null,
    }
  }

  render() {
    return (
      <RfTransactionListPageUI
        context={this.props.context}
        account={this.state.account}
        customerInvoiceList={this.state.customerInvoiceList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getRfTransactions(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getRfTransactions(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/receivableFinancing/transactions`,
      cacheKey: CacheKeys.RfTransactions(this.props.match.params.accountId),
      callback: this.getRfTransactionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }
  getRfTransactionsCallback = (response) => {
    this.setState({ customerInvoiceList: response.customerInvoiceList })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Account(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.RfTransactions(this.props.match.params.accountId))
    this.setState({ customerInvoiceList: null },
      () => {
        this.getAccounts(context)
        this.getRfTransactions(context)
      }
    )
  }
}

export default withRouter(RfTransactionListPageSF)
